import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { IsNullOrEmpty } from "../../../services/CustomService";
import {
    Form,
    NavLink,
    useLoaderData,
} from "react-router-dom";
import { getServices, getServicePaymentFlow, formatCommission } from "../../../data/loca/services";

export async function loader({ params }) {
    const services = await getServices();
    return { services };
}

export default function ServicesList() {
    const { services } = useLoaderData();

    const pictureTemplate = (rowData) => {
        return (
            <div className="tools-list-name-cell platforms-list-name-cell">
                {(!IsNullOrEmpty(rowData.base64Picture)) ? (
                    <img className="tools-list-thumb" key={rowData.id} alt={rowData.name} src={rowData.base64Picture || null} />
                ) : (
                    <div className="tools-list-thumb tools-list-thumb-empty"></div>
                )}
                <span>
                    <b>{rowData.name}</b>
                    <small>{rowData.isPublic ? "Plateforme publique" : "Plateforme personnalisée"}</small>
                </span>
            </div>
        );
    };

    const linkTemplate = (rowData) => {
        if (!rowData.canEdit) {
            return <span className="platforms-list-muted">Incluse</span>;
        }

        return (
            <NavLink className="platforms-list-link" to={`/administration/plateformes/${rowData.id}`}>
                <i className="pi pi-file-edit"></i>
                <span>Détails</span>
            </NavLink>
        );
    };

    const paymentFlowTemplate = (rowData) => (
        <span className="platforms-list-muted">{getServicePaymentFlow(rowData.paymentFlow).label}</span>
    );

    const commissionTemplate = (rowData) => (
        <span className="platforms-list-muted">{formatCommission(rowData.commissionPercent)}</span>
    );

    const contractTermsTemplate = (rowData) => (
        <span className="platforms-list-muted">{(rowData.contractTerms || "").trim() ? "Oui" : "—"}</span>
    );

    return (
        <div className="tools-list-page platforms-list-page">
            <div className="tools-list-page-header">
                <div className="tools-list-page-title">
                    <i className="pi pi-globe"></i>
                    <div>
                        <p className="tools-list-kicker">Administration</p>
                        <h1>Liste des plateformes</h1>
                        <p>Administrez les plateformes utilisées dans vos flux de location.</p>
                    </div>
                </div>
                <Form className="tools-list-add-button" method="get" action="/administration/plateformes/ajout">
                    <Button icon="pi pi-plus" type="submit" size="small">Ajouter une plateforme</Button>
                </Form>
            </div>

            <section className="platforms-list-info">
                <div>
                    <h2>Règles par plateforme</h2>
                    <p>Chaque plateforme a ses spécificités. Par exemple, avec <b>Bricolib</b>, un code doit être récupéré auprès du locataire <u>avant</u> la location. Pour <b>Kiwiiz</b>, ce code est demandé <u>après</u> la location et reste visible sur la page de gestion. Avec <b>Toolzy</b>, il suffit de confirmer le retrait. Le mode de paiement, la commission et l'article 3bis du contrat de chaque plateforme se règlent sur sa fiche.</p>
                </div>
                <div>
                    <h2>Plateformes personnalisées</h2>
                    <p>Si vous utilisez un service qui n'est pas listé, vous pouvez l'ajouter pour adapter vos suivis et limiter les oublis au quotidien.</p>
                </div>
            </section>

            <div className="tools-list-card">
                <DataTable className="tools-list-table platforms-list-table" value={services} paginator rows={10} dataKey="id" emptyMessage="Aucune plateforme trouvée">
                    <Column header="Plateforme" body={pictureTemplate} />
                    <Column header="Paiement" body={paymentFlowTemplate} />
                    <Column header="Commission" body={commissionTemplate} />
                    <Column header="Article 3bis" body={contractTermsTemplate} />
                    <Column header="" body={linkTemplate} style={{ width: '8rem' }} />
                </DataTable>
            </div>
        </div>
    );
}
